import React from 'react';
import { INSTRUMENT_COLORS } from '@/utils/constants';
import { Play, Square, Plus } from 'lucide-react';

export const LoopCard = ({ loop, isPreviewPlaying, onPreview, onStopPreview, onAddTrack }) => {
  const color = INSTRUMENT_COLORS[loop.instrument_group] || '#666';
  const playing = isPreviewPlaying === loop.id;

  return (
    <div
      data-testid={`loop-card-${loop.id}`}
      className="flex items-center gap-2 px-3 py-2 cursor-pointer transition-colors group"
      style={{
        background: 'var(--bg-card)', borderRadius: 8,
        border: `1px solid ${playing ? color : 'var(--border)'}`,
      }}
    >
      {/* Play/Stop preview button */}
      <button
        data-testid={`loop-preview-${loop.id}`}
        onClick={(e) => { e.stopPropagation(); playing ? onStopPreview?.() : onPreview?.(loop); }}
        className="shrink-0 flex items-center justify-center transition-opacity"
        style={{
          width: 26, height: 26, borderRadius: '50%',
          background: playing ? color : `${color}22`, color: playing ? '#fff' : color,
        }}
      >
        {playing ? <Square size={9} fill="currentColor" /> : <Play size={11} fill="currentColor" />}
      </button>

      {/* Loop info */}
      <div className="flex flex-col flex-1 min-w-0 gap-0.5">
        <span className="truncate" style={{ fontSize: 12, fontWeight: 600, color: 'var(--text)' }}>
          {loop.name}
        </span>
        <div className="flex items-center gap-2">
          <span style={{ fontSize: 10, color: 'var(--text-dim)' }}>{loop.bpm} BPM</span>
          <span style={{ fontSize: 10, color: 'var(--text-dim)' }}>{loop.key}</span>
          <span style={{ fontSize: 10, color: 'var(--text-dim)' }}>{loop.bars ? `${loop.bars}bar` : 'Full loop'}</span>
        </div>
      </div>

      {/* Energy dots */}
      <div className="flex items-center gap-0.5 shrink-0">
        {Array.from({ length: 5 }, (_, i) => (
          <div
            key={i}
            className="rounded-full"
            style={{
              width: 5, height: 5,
              background: i < loop.energy ? 'var(--green)' : 'var(--border)',
            }}
          />
        ))}
      </div>

      {/* Instrument badge */}
      <span
        className="shrink-0"
        style={{
          fontSize: 9, fontWeight: 600, color: 'var(--bg)',
          background: color, padding: '1px 6px', borderRadius: 22,
        }}
      >
        {loop.instrument_group}
      </span>

      {/* Add to timeline button */}
      <button
        data-testid={`loop-add-${loop.id}`}
        onClick={(e) => { e.stopPropagation(); onAddTrack?.(loop); }}
        className="shrink-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
        style={{
          width: 22, height: 22, borderRadius: '50%',
          background: 'var(--green)', color: 'var(--bg)',
        }}
      >
        <Plus size={12} />
      </button>
    </div>
  );
};

export default LoopCard;
